/* (ignored) */


//////////////////
// WEBPACK FOOTER
// canvas (ignored)
// module id = 343
// module chunks = 0